import React from 'react'
import { Grid, Typography, Divider, Paper, Box  } from '@mui/material'
import { Progress } from 'react-sweet-progress';
import '../../../styles/report.css'
import {motion, AnimatePresence} from "framer-motion/dist/framer-motion"

/** 
 * 
 * This component is expecting the following input. 
{
    "Order": "50",
    "Visible": "1",
    "Label": "Readiness to Change",
    "ComponentType": "READINESS TO CHANGE",
    "ComponentValues": [
        {
            "Order": "10",
            "Visible": "1",
            "Label": "Exercise",
            "Value": "Recent change",
            "Color": "#209D70",
            "PipCount": "4"
        }
    ]
}
    }
*/

const ReadinessToChange = (props) => {
    const data = [...props.component.ComponentValues].sort((a, b) => { return parseInt(a.Order) - parseInt(b.Order) })

    const motionVariants = {
        hidden: { opacity: 0, x: 0, y: 0 },
        show: {
          opacity: 1, x: 0, y: 0,
          transition: {
            delay: 0.1,
            duration: 0.5,
          }
        }
      }
      
    const ProgressBar = ({ percent, status }) => {
        return (
            <Progress
                theme={{
                    success: {
                        symbol: ' ',// <HealthAndSafetyIcon sx={{ color: '#4eb748' }} />,
                        color: '#4eb748'
                    },
                    default: {
                        symbol: ' ', // <WarningIcon sx={{ color: '#E7C61E' }} />,
                        color: '#E7C61E'
                    },
                    error: {
                        symbol: ' ',//<DangerousIcon sx={{ color: '#9A3218' }} />,
                        color: '#E6323A'
                    },
                    active: {
                        symbol: ' ',//<DangerousIcon sx={{ color: '#9A3218' }} />,
                        color: '#AEAEAE'
                    }
                }}
                percent={percent}
                status={status}
            />
        )
    }

    const DisplayItem = ({ displayValues }) => {
        const progressValue = parseInt(displayValues.PipCount) * 20
        const progressStatus = displayValues.PipCount === '4' || displayValues.PipCount === '5' ? 'success'
            : displayValues.PipCount === '3' ? 'default' : 'error'
        return (
            <Box sx={{ borderBottom: 1, borderColor: "rgba(200,200,200,0.4)" }}>
                <Grid container direction="row" alignItems="center">
                    <Grid item xs={4}>
                        <Typography variant="body2" align="left">{displayValues.Label}</Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <ProgressBar percent={progressValue} status={progressStatus} />
                    </Grid>
                    <Grid item xs={4}>
                        <Typography variant="body2" align="left">{displayValues.Value}</Typography>
                    </Grid>

                </Grid>
            </Box>
        )
    }

    return (
        <Grid item lg={6} md={6} sm={4} xs={12} justifyContent="center" alignItems="center" sx={{ padding: '10px' }}>
            <motion.div variants={motionVariants} initial="hidden" animate="show" >

            <Paper elevation={props.elevationdisabled === true ? 0 : 1} sx={{ padding: '40px', height: '100%' }}>
                <Grid container direction="row" alignItems="center" justifyContent="center">
                    <Grid item xs={12}>
                        <Typography variant="h5" align="center">{props.component.Label}</Typography>
                    </Grid>
                    <Grid item xs={12} m={1}>
                        <Divider orientation='horizontal' sx={{ borderColor: "rgba(0,0,0,0.1)", borderRadius: '90%', borderBottomWidth: 2 }} />
                    </Grid>
                    <Grid item xs={12}>
                        {
                            data && data.map((displayValues, index) => {
                                return (
                                    <DisplayItem displayValues={displayValues} key={"demographics" + index} />
                                    )
                                })
                            }
                    </Grid>
                </Grid>
            </Paper>
                            </motion.div>
        </Grid>
    )
}

export default ReadinessToChange